import { FieldPath, useFormContext } from 'react-hook-form';

export const useFormError = <T extends Record<string, unknown>>(
	name: FieldPath<T>,
) => {
	const { formState } = useFormContext<T>();
	const isError = !!formState.errors[name];
	const error = formState.errors[name];
	const errorText = error?.message as string | undefined;

	return {
		error,
		errorText,
		isError,
		isSubmitting: formState.isSubmitting,
	};
};
